// import { login, getuserid } from '@/api/user'
import { setToken, setUserInfo, delToken, delUserInfo, getUserInfo, getToken } from '@/libs/utils'

export default {
  state: {
    token: null,
    userInfo: null,
    subject: null,
    teacher: null,
    currentTeacher: null,
    authParams: null // 存储临时授权参数
  },
  mutations: {
    SET_AUTH_PARAMS(state, params) {
      state.authParams = params;
    },
    CLEAR_AUTH_PARAMS(state) {
      state.authParams = null;
    },
    setToken(state, token) {
      state.token = token
      setToken(token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      setUserInfo(userInfo)
    },
    setSubject(state, subject) {
      state.subject = subject
    },
    setTeacher(state, teacher) {
      state.teacher = teacher
    },
    setCurrentTeacher(state, currentTeacher) {
      state.currentTeacher = currentTeacher
    },
    delTeacher(state) {
      state.teacher = null
    },
    delCurrentTeacher(state) {
      state.currentTeacher = null
    },
    delToken(state) {
      state.token = null
      delToken()
    },
    delUserInfo(state) {
      state.userInfo = null
      delUserInfo()
    },
    delSubject(state) {
      state.subject = null
    }
  },
  getters: {
    getToken: () => getToken(),
    getUserInfo: () => getUserInfo(),
  },
  actions: {
    // async handleDingDingLogin({ commit }, { code, state }) {
    //   console.log(commit)
    //   const response = await getuserid({ code, state })
    //   console.log(response)
    //   commit('setToken', "2965a9c69d69d01c27bd3c0bf287a172")
    //   commit('setUserInfo', {
    //     "access": [
    //       "bmc-ceo",
    //       "super_admin"
    //     ],
    //     "fcompanyid": "A925AF54-BB87-474E-A924-350A7F124C71",
    //     "fcustname": "",
    //     "fcustno": "",
    //     "flevel": 2,
    //     "floginname": "admin",
    //     "fpositionid": "DC306ABF-1EDE-479B-B086-502906AAE788",
    //     "fstatus": "",
    //     "fuserid": "02A0BFDE-3151-4FE2-9682-B2F544BC0450",
    //     "logourl": "http://server.1000classes.com/bmcserver/attachment/2019-11/ee8cd0c5-5e86-42e9-abe4-4dd4ac20bd55.png?time=250627",
    //     "smalllogourl": "http://server.1000classes.com/bmcserver/attachment/2019-12/9da755e0-115c-4c74-8326-d1ce392d2395.png?time=250627"
    //   })
    // },
  },
}
